import React, { useEffect, useState } from "react";
import styles from "../../initial/layersPopup/Menu.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faLayerGroup } from "@fortawesome/free-solid-svg-icons";
import AddLayerComp from "../../initial/layersPopup/AddLayerComp";
import Draggable from "react-draggable";
import EagleILogo from "../../assets/Eagle_I_Logo.png";
import { useAirQualityContext } from "../../provider/AirQualityProvider";
import { useRiverContext } from "../../provider/RiverProvider";
import { useRainfallContext } from "../../provider/RainfallProvider";

type MinMenuPropsType = {
  closePopupDropDown: (open: boolean) => void;
  getValueFromLefSideMenu: string;
  openLayerTypeMap: Map<string, boolean>;
  handleButtonClickMinMenuRain: (open: boolean) => void;
  handleButtonClickMinMenuRiver: (open: boolean) => void;
  handleButtonClickMinMenuAir: (open: boolean) => void;
  minMenuAir: boolean;
  minMenuRiver: boolean;
  minMenuRain: boolean;
  addLayerPopupFromMini: (open: boolean) => void;
  getUser:string;
};

const MinMenu = ({
  closePopupDropDown,
  getValueFromLefSideMenu,
  openLayerTypeMap,
  handleButtonClickMinMenuRain,
  handleButtonClickMinMenuRiver,
  handleButtonClickMinMenuAir,
  minMenuAir,
  minMenuRiver,
  minMenuRain,
  addLayerPopupFromMini,
  getUser
}: MinMenuPropsType) => {
  const toggleDropDown = () => {
    closePopupDropDown(false);
    //  layerValueFromMainMenu("main");
  };

  let [isMenuOpen, setIsMenuOpen] = useState<boolean>(true);
  let [isAddLayerOpen, setIsAddLayerOpen] = useState<boolean>(false);
  const { setIsLeftkeyClick, isLeftkeyClick,isLeftAir,setIsMinEyeClickAir } = useAirQualityContext();
  const { isLeftkeyClickRiver, setIsLeftkeyClickRiver,isLeftRiver,setIsMinEyeClickRiver } = useRiverContext();
  const { isLeftkeyClickRain, setIsLeftkeyClickRain,isLeftRain,setIsMinEyeClickRain  } = useRainfallContext();
  // Menu open close function
  const OpenMenu = () => {
    if (isMenuOpen === true) {
      setIsMenuOpen(false);
    } else {
      setIsMenuOpen(true);
    }
  };

  // Set add layer popup status
  const OpenAddLayerPopup = () => {
    if (isAddLayerOpen === true) {
      setIsAddLayerOpen(false);
    } else {
      setIsAddLayerOpen(true);
    }
  };

  let [isEyeOpenRain, setIsEyeOpenRain] = useState<boolean>(false);
  let [isEyeOpenRiver, setIsEyeOpenRiver] = useState<boolean>(false);
  let [isEyeOpenAir, setIsEyeOpenAir] = useState<boolean>(false);

  const VisibilityButton = () => {
    setIsMinEyeClickRain(true);
    if (isEyeOpenRain === true) {
      setIsEyeOpenRain(false);
      if (isLeftkeyClickRain) {
        if(!isLeftRain){
          handleButtonClickMinMenuRain(true);
        }else{
          handleButtonClickMinMenuRain(false);
        }
        setIsLeftkeyClickRain(false);
      } else {
        if (isLeftRain) {
          handleButtonClickMinMenuRain(false);
        } else {
          handleButtonClickMinMenuRain(true);
        }
      }
    } else {
      setIsEyeOpenRain(true);
      setIsLeftkeyClickRain(false);

      if (isLeftkeyClickRain) {
        handleButtonClickMinMenuRain(false);
      } else {
        if(!isLeftRain){
          handleButtonClickMinMenuRain(false);
        }else{
          handleButtonClickMinMenuRain(true);
        }
      }
    }
  };

  const VisibilityButtonRiver = () => {
    setIsMinEyeClickRiver(true);
    if (isEyeOpenRiver === true) {
      setIsEyeOpenRiver(false);
      if (isLeftkeyClickRiver) {
        if(!isLeftRiver){
          handleButtonClickMinMenuRiver(true);
        }else{
          handleButtonClickMinMenuRiver(false);
        }
        setIsLeftkeyClickRiver(false);
      } else {
        if (isLeftRiver) {
          handleButtonClickMinMenuRiver(false);
        } else {
          handleButtonClickMinMenuRiver(true);
        }
      }
    } else {
      setIsEyeOpenRiver(true);
      setIsLeftkeyClickRiver(false);
      if (isLeftkeyClickRiver) {
        handleButtonClickMinMenuRiver(false);
      } else {
        if(!isLeftRiver){
          handleButtonClickMinMenuRiver(false);
        }else{
          handleButtonClickMinMenuRiver(true);
        }
      }
    }
  };

  const VisibilityButtonAir = () => {
    setIsMinEyeClickAir(true)
    if (isEyeOpenAir === true) {
      setIsEyeOpenAir(false);
      if (isLeftkeyClick) {
        if(!isLeftAir){
          handleButtonClickMinMenuAir(true);
        }else{
          handleButtonClickMinMenuAir(false);
        }
        setIsLeftkeyClick(false);
      } else {
        if (isLeftAir) {
          handleButtonClickMinMenuAir(false);
        } else {
          handleButtonClickMinMenuAir(true);
        }
      }
    } else {
      setIsEyeOpenAir(true);
      setIsLeftkeyClick(false);
      if (isLeftkeyClick) {
        handleButtonClickMinMenuAir(false);
      } else {
        if(!isLeftAir){
          handleButtonClickMinMenuAir(false);
        }else{
          handleButtonClickMinMenuAir(true);
        }
      }
    }
  };

  useEffect(() => {
    openLayerTypeMap.forEach((value, key) => {
      if (value === true) {
        if (key === "river") {
          setIsEyeOpenRiver(true);
        } else if (key === "airquality") {

          setIsEyeOpenAir(true);
        } else if (key === "rain") {
          setIsEyeOpenRain(true);
        } else {
          if (key === "river") {
            setIsEyeOpenRiver(false);
          } else if (key === "airquality") {
            setIsEyeOpenAir(false);
          } else if (key === "rain") {
            setIsEyeOpenRain(false);
          }
        }
      }
    });
  }, [openLayerTypeMap]);

  useEffect(() => {
    if (minMenuAir) {
      setIsEyeOpenAir(false);
    } else {
      setIsEyeOpenAir(true);
    }
  }, [minMenuAir]);

  useEffect(() => {
    if (minMenuRiver) {
      setIsEyeOpenRiver(false);
    } else {
      setIsEyeOpenRiver(true);
    }
  }, [minMenuRiver]);

  useEffect(() => {
    if (minMenuRain) {
      setIsEyeOpenRain(false);
    } else {
      setIsEyeOpenRain(true);
    }
  }, [minMenuRain]);

  useEffect(() => {
  }, [getUser]);

  const handleAddLayerPopup = () => {
    addLayerPopupFromMini(true);
  };

  return (
    <>
      <div>
        <Draggable handle=".drag-handle" enableUserSelectHack={false}>
          <div className="drag-handle">
            <div className={styles.menuContainer}>
              <div className={styles.titleContainer}>
                <img src={EagleILogo} width={"10%"} height={"10%"} />
              </div>

              <div
                className={styles.tabContainer}
                style={{
                  display: "flex",
                  height: "auto",
                }}
              >
                <div className={styles.menuTabContainer}>
                  <div
                    className={styles.contentContainer}
                    style={{
                      height: "32px",
                      flexDirection: "row",
                      justifyContent: "center",
                      padding: "0",
                    }}
                  >
                    <div className={styles.overlayItem}>
                      <div className={styles.header}>
                        <div
                          className={styles.headerCell}
                          style={{ gridArea: `a` }}
                        >
                          <img
                            src={
                              isEyeOpenRain
                                ? require("../../assets/eye-open.png")
                                : require("../../assets/eye-close.png")
                            }
                            alt=""
                            onClick={() => {
                              VisibilityButton();
                              // setClickedPopup(true);
                            }}
                            onTouchStart={() => {
                              VisibilityButton();
                              // setClickedPopup(true);
                            }}
                          />
                        </div>
                        <div
                          className={styles.headerCell}
                          style={{ gridArea: `b` }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "flex-start",
                              alignItems: "center",
                              fontSize: "0.8rem",
                              width: "100%",
                            }}
                          >
                            Rainfall
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {(getUser==="test" || getUser==="admin" || getUser==="nbroofficer" || getUser==="irrigationofficer" || getUser==="gaofficer") &&
                              <div className={styles.menuTabContainer}>
                              <div
                                className={styles.contentContainer}
                                style={{
                                  height: "32px",
                                  flexDirection: "row",
                                  justifyContent: "center",
                                  padding: "0",
                                }}
                              >
                                <div className={styles.overlayItem}>
                                  <div className={styles.header}>
                                    <div
                                      className={styles.headerCell}
                                      style={{ gridArea: `a` }}
                                    >
                                      <img
                                        src={
                                          isEyeOpenRiver
                                            ? require("../../assets/eye-open.png")
                                            : require("../../assets/eye-close.png")
                                        }
                                        alt=""
                                        onClick={() => {
                                          VisibilityButtonRiver();
                                          // setClickedPopup(true);
                                        }}
                                        onTouchStart={() => {
                                          VisibilityButtonRiver();
                                          // setClickedPopup(true);
                                        }}
                                      />
                                    </div>
                                    <div
                                      className={styles.headerCell}
                                      style={{ gridArea: `b` }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                          justifyContent: "flex-start",
                                          alignItems: "center",
                                          fontSize: "0.8rem",
                                          width: "100%",
                                        }}
                                      >
                                        River Sensor
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div> }
                    
                            {(getUser==="test" || getUser==="admin" || getUser==="nbroofficer" || getUser==="metofficer" ) &&
                                            <div className={styles.menuTabContainer}>
                                            <div
                                              className={styles.contentContainer}
                                              style={{
                                                height: "32px",
                                                flexDirection: "row",
                                                justifyContent: "center",
                                                padding: "0",
                                              }}
                                            >
                                              <div className={styles.overlayItem}>
                                                <div className={styles.header}>
                                                  <div
                                                    className={styles.headerCell}
                                                    style={{ gridArea: `a` }}
                                                  >
                                                    <img
                                                      src={
                                                        isEyeOpenAir
                                                          ? require("../../assets/eye-open.png")
                                                          : require("../../assets/eye-close.png")
                                                      }
                                                      alt=""
                                                      onClick={() => {
                                                        VisibilityButtonAir();
                                                        // setClickedPopup(true);
                                                      }}
                                                      onTouchStart={() => {
                                                        VisibilityButtonAir();
                                                        // setClickedPopup(true);
                                                      }}
                                                    />
                                                  </div>
                                                  <div
                                                    className={styles.headerCell}
                                                    style={{ gridArea: `b` }}
                                                  >
                                                    <div
                                                      style={{
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        justifyContent: "flex-start",
                                                        alignItems: "center",
                                                        fontSize: "0.8rem",
                                                        width: "100%",
                                                      }}
                                                    >
                                                      Air Quality
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>}

              </div>
              <div className={styles.buttonContainer}>
                <div className={styles.cell} style={{ gridArea: "a" }}>
                  <FontAwesomeIcon
                    size="1x"
                    icon={faLayerGroup}
                    color="white"
                  />
                  <div
                    style={{
                      marginLeft: "10px",
                      cursor: `pointer`,
                    }}
                    onClick={handleAddLayerPopup}
                    onTouchStart={handleAddLayerPopup}
                  >
                    <span>Add Layers +</span>
                  </div>
                </div>
                <div
                  className={styles.cell}
                  style={{
                    gridArea: "b",
                    backgroundColor: "#3452eb",
                    cursor: `pointer`,
                    marginRight: `10px`,
                  }}
                  onClick={toggleDropDown}
                  onTouchStart={toggleDropDown}
                >
                  <span>Close</span>
                  <div
                    style={{
                      marginLeft: "10px",
                    }}
                  >
                    <FontAwesomeIcon size="1x" icon={faClose} color="white" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Draggable>
      </div>
      {isAddLayerOpen && <AddLayerComp close={OpenAddLayerPopup} />}
    </>
  );
};

export default MinMenu;
